
import $ from 'jquery';
export default {
  props: {
    location: {
      type: String,
      default: 'Australia'
    }
  },
  data() {
    return {
      selectedLocation: null,
      locations: [
        {
          name: "Australia",
          url: "https://burstsms.com.au"
        },
        {
          name: "Canada",
          url: "https://www.burstsms.ca"
        },
        {
          name: "Hong Kong",
          url: "https://www.burstsms.com.hk"
        },
        {
          name: "New Zealand",
          url: "https://www.burstsms.co.nz"
        },
        {
          name: "Philippines",
          url: "https://burstsms.com.ph"
        },
        {
          name: "Singapore",
          url: "https://www.burstsms.com.sg"
        },
        {
          name: "United Kingdom",
          url: "https://www.burstsms.co.uk"
        },
        {
          name: "United States",
          url: "https://www.burstsms.com"
        }
      ]
    };
  },
  created() {
    this.selectedLocation = {...this.locations.find(c => c.name.toLowerCase() === this.location.toLowerCase())};
    // remove current location
    this.locations = this.locations.filter(c => c.name.toLowerCase() !== this.location.toLowerCase());
  },
  mounted(){
    $(function(){
      $('.location-dropdown button').click(function(event){
        event.preventDefault();
        event.stopImmediatePropagation();

        if($('footer').hasClass('footer--sticky')){
          $('html, body').animate({
            scrollTop: $('footer').offset().top
          }, 500);
        }
      });
    });
  }
}
